// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3vH3T","footer":"ModalInfo_footer__212rZ"};